import React, { useCallback, useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { Link } from 'react-router-dom';
import withWidth from '@material-ui/core/withWidth';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../auth/store/loginSlice';
import { useHistory } from 'react-router';
import useSimplyTeam from '../../../pch/hooks/useSimplyTeam';
import useActiveMenu from '../../../pch/hooks/useActiveMenu';
import UserActionButton from './UserActionButton';
import { useTranslation } from 'react-i18next';
import SignedMedia from '../../../pch/components/SignedMedia';

function TopBar(props) {
	const [anchorEl, setAnchorEl] = useState(null);
	const user = useSelector(({ auth }) => auth.user);
	const { logout } = useAuth0();
	const dispatch = useDispatch();
	const openProfile = Boolean(anchorEl);
	const history = useHistory();
	const { sb } = useSimplyTeam();
	const { active, setActive } = useActiveMenu();
	const { t } = useTranslation();

	const handleProfileMenuOpen = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleCloseProfile = useCallback(() => {
		setAnchorEl(null);
	}, []);

	const handleViewProfile = () => {
		handleCloseProfile();
		history.push('/profile');
	};

	const handleLogout = () => {
		logout();
		dispatch(logoutUser());
	};

	const handleActiveMenu = e => {
		setActive(e.target.id === 'logo' ? 'dashboard' : e.target.id);
	};

	const activeMenu = () => {
		return 'border-b-4 pb-4 border-green-400';
	};

	return (
		<>
			<AppBar position='absolute'>
				<Toolbar className='bg-gradient-to-r from-white via-sbBrightGreen to-sbBrightBlue text-black flex'>
					{/* <IconButton
						edge='start'
						color='inherit'
						aria-label='open drawer'
						onClick={handleDrawerOpen}
						className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
					>
						<MenuIcon />
					</IconButton> */}
					<div id='logo' className='flex-auto lg:flex-initial bg-white' onClick={handleActiveMenu}>
						<Link to='/'>
							<img src='/assets/img/logo.png' alt="SimplyBorrowed's logo" className='max-h-16 h-40' />
						</Link>
					</div>

					<div className='flex-auto text-left hidden lg:block bg-white max-h-16 h-40 pt-5 pl-16'>
						<div className='flex gap-7'>
							<div
								id='dashboard'
								className={active === 'dashboard' ? activeMenu() : ''}
								onClick={handleActiveMenu}
							>
								<Link to='/'>{t('Dashboard')}</Link>
							</div>
							{/* <div id='loans' onClick={handleActiveMenu} className={active === 'loans' ? activeMenu() : ''}>
								<Link to='/loans'> Loans</Link>
							</div> */}

							{sb && (
								<>
									<div
										id='payments'
										className={active === 'payments' ? activeMenu() : ''}
										onClick={handleActiveMenu}
									>
										<Link to='/payments'>{t('Payments')}</Link>
									</div>
									<div
										id='people'
										className={active === 'people' ? activeMenu() : ''}
										onClick={handleActiveMenu}
									>
										<Link to='/people'>{t('Users')}</Link>
									</div>
									<div
										id='marketing'
										className={active === 'marketing' ? activeMenu() : ''}
										onClick={handleActiveMenu}
									>
										<Link to='/marketing/links'>{t('Marketing')}</Link>
									</div>
									<div
										id='settings'
										className={active === 'settings' ? activeMenu() : ''}
										onClick={handleActiveMenu}
									>
										<Link to='/settings'>{t('Settings')}</Link>
									</div>
								</>
							)}

							<div id='help' className={active === 'help' ? activeMenu() : ''} onClick={handleActiveMenu}>
								<Link to='/help'>{t('Help')}</Link>
							</div>
						</div>
					</div>
					<div className='flex-none hidden lg:block bg-white max-h-16 h-40'>
						<IconButton onClick={handleProfileMenuOpen}>
							{user.avatar_url ? (
								<SignedMedia src={user.avatar_url} alt='Default Profile' className='w-8 rounded-full' />
							) : (
								<img src='/assets/img/default.jpg' alt='Profile' className='w-8 rounded-full' />
							)}
						</IconButton>
						<Menu
							id='menu-appbar'
							anchorEl={anchorEl}
							anchorOrigin={{
								vertical: 'top',
								horizontal: 'right',
							}}
							keepMounted
							transformOrigin={{
								vertical: 'top',
								horizontal: 'right',
							}}
							open={openProfile}
							onClose={handleCloseProfile}
						>
							<MenuItem onClick={handleViewProfile}>{t('Profile')}</MenuItem>
							<MenuItem onClick={handleLogout}>{t('Logout')}</MenuItem>
						</Menu>
					</div>
					<div className='flex-initial h-40 max-h-16 bg-white'>
						<div className='h-40 max-h-16 bg-gradient-to-r from-sbBrightGreen to-sbBrightBlue pch-trapezoide-clipping'>
							<div className='w-60 pl-16 pt-2'>
								{user?.role?.toUpperCase() === 'CLIENT' && <UserActionButton />}
							</div>
						</div>
					</div>
				</Toolbar>
			</AppBar>
			{/* <Drawer
				{...(isWidthUp('md', props.width) ? { variant: 'permanent' } : { variant: 'temporary' })}
				classes={{
					paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
				}}
				open={open}
			>
				<div className={classes.toolbarIcon}>
					<IconButton onClick={handleDrawerClose}>
						<ChevronLeftIcon />
					</IconButton>
				</div>
				<Divider />
				<MainListItems />
			</Drawer> */}
		</>
	);
}

export default withWidth()(TopBar);
